import { Button } from '@radix-ui/themes'
import CollapseIcon from 'assets/arrow-left-to-line.svg?react'
import ExpandIcon from 'assets/arrow-right-from-line.svg?react'
import React from 'react'
import styled from 'styled-components'

import { ProfileAndSettings } from './ProfileAndSettings'
import { ImageContainer } from './sharedStyles'

const BottomSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 auto; /* Do not grow or shrink, set a fixed height */
  gap: 0.125rem;
`

const CollapseLeftIcon = styled(CollapseIcon)`
  path {
    stroke: ${({ theme }) => theme.forecast.tertiaryText};
  }

  &:active {
    path {
      stroke: ${({ theme }) => theme.forecast.secondaryText};
    }
  }

  height: 18px;
  width: 18px;
`

const ExpandRightIcon = styled(ExpandIcon)`
  path {
    stroke: ${({ theme }) => theme.forecast.tertiaryText};
  }

  &:active {
    path {
      stroke: ${({ theme }) => theme.forecast.secondaryText};
    }
  }

  height: 18px;
  width: 18px;
`

const StyledButton = styled(Button)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 40px;
  cursor: pointer;
  color: ${({ theme }) => theme.forecast.secondaryText};
  background-color: ${({ theme }) => theme.forecast.defaultGhostButton};
  border-radius: 0.5rem;

  &:hover {
    background-color: ${({ theme }) => theme.forecast.hoverGhostButton};
  }

  &:active {
    background-color: ${({ theme }) => theme.forecast.activeGhostButton};
    color: ${({ theme }) => theme.forecast.defaultText};
  }
`

export const BottomSection: React.FC<{
  isLeftSidebarOpen: boolean
  toggleIsLeftSidebarOpen: () => void
  orgID: string | undefined
}> = ({ isLeftSidebarOpen, toggleIsLeftSidebarOpen, orgID }) => {
  return (
    <BottomSectionContainer>
      <ProfileAndSettings isLeftSidebarOpen={isLeftSidebarOpen} orgID={orgID} />
      <StyledButton onClick={toggleIsLeftSidebarOpen}>
        <ImageContainer>
          {isLeftSidebarOpen ? <CollapseLeftIcon /> : <ExpandRightIcon />}
        </ImageContainer>
        {isLeftSidebarOpen ? <p>Hide sidebar</p> : null}
      </StyledButton>
    </BottomSectionContainer>
  )
}
